import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'default' | 'large';
}

export default function ComicCard({ comic, size = 'default' }: ComicCardProps) {
  const isLarge = size === 'large';

  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block cursor-pointer"
    >
      <div className={`relative overflow-hidden rounded-lg bg-background-100 transition-all duration-300 group-hover:scale-[1.02] ${
        isLarge ? 'aspect-[3/4]' : 'aspect-[3/4]'
      }`}>
        <img
          src={comic.coverImage}
          alt={comic.title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          title={`${comic.title} - 韩漫吧免费韩国漫画在线阅读`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <p className="text-white text-xs line-clamp-2 leading-relaxed">{comic.description}</p>
        </div>
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-full text-[10px] font-medium ${
            comic.status === '已完结'
              ? 'bg-accent-500 text-white'
              : 'bg-primary-500 text-white'
          }`}>
            {comic.status}
          </span>
        </div>
        <div className="absolute top-2 right-2">
          <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-black/60 text-accent-400 flex items-center gap-0.5">
            <i className="ri-star-fill text-[9px]"></i>
            {comic.rating}
          </span>
        </div>
      </div>
      <div className={`mt-2.5 ${isLarge ? 'px-1' : 'px-0.5'}`}>
        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {comic.title}
        </h3>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-xs text-foreground-500">{comic.author}</span>
          <span className="text-[10px] text-foreground-400">·</span>
          <span className="text-xs text-foreground-500 flex items-center gap-0.5">
            <i className="ri-eye-line text-[10px]"></i>
            {comic.views >= 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views}
          </span>
        </div>
      </div>
    </Link>
  );
}